import React from 'react';
import styles from './AddressFilterCard.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { CardDesign } from '../../../../../../components/CardDesign';
import FilterField from '../../../../shared/ui/FilterField/FilterField';
import { Select } from 'antd';
import { ReactComponent as AddressIcon } from '../../../../../../resource/AddressIcon.svg';
import useRequestStreetsByServiceCompany from '../../../../../../queries/useRequestStreetsByServiceCompany';

import useRequestHouses from '../../../../../../queries/useRequestHouses';
import useTransportPermitsMatch from '../../../../shared/hooks/useTransportPermitsMatch';
import useRequestAddresses from '../../../../../../queries/useRequestAddresses';
import { applyPermitFilter } from '../../../../shared/store/action';
import {
  SET_FLAT_ID_PERMIT_FILTER,
  SET_HOUSE_ID_PERMIT_FILTER,
  SET_STREET_ID_PERMIT_FILTER,
} from '../../../../shared/store/types';
import cn from 'classnames';
import { countValues } from '../../lib/countValues';

const typeFlat = {
  FLAT: 3, // квартира
  STORAGE: 5, // кладовка
  OFFICE: 7, // офис
};

export const getOptionsByDrobdownSelect = (data = []) => {
  if (!Array.isArray(data)) return [];

  return data?.map((item) => (
    <Select.Option
      key={item.id}
      value={item.id}
      searchtext={item.name}
    >
      {`${
        item.typeId === typeFlat.FLAT ||
        item.typeId === typeFlat.STORAGE ||
        item.typeId === typeFlat.OFFICE
          ? item.typeShortName
          : ''
      } ${item.name} `}
    </Select.Option>
  ));
};

const AddressFilterCard = () => {
  const dispatch = useDispatch();

  const { streetId, houseId, addressId } = useSelector(
    (state) => state.permitsFilterStore
  );

  const match = useTransportPermitsMatch();

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;

  const { data: streetsByCompany = [], isFetching: isStreetByCompanyFetching } =
    useRequestStreetsByServiceCompany(
      { serviceCompanyIds: [urlCompanyId] },
      { staleTime: Infinity, enabled: !!urlCompanyId }
    );
  const { data: houses = [], isFetching: isHouseFetching } = useRequestHouses(
    streetId,
    {
      enabled: Boolean(streetId),
    }
  );
  const { data: flats = [], isFetching: isFlatFetching } = useRequestAddresses(
    houseId,
    {
      enabled: Boolean(houseId && streetId),
    }
  );

  const makeChangeHandler = (actionType) => (value) => {
    dispatch(applyPermitFilter(actionType)(value));
  };

  const handleChangeStreet = (value) => {
    makeChangeHandler(SET_STREET_ID_PERMIT_FILTER)(value);
    makeChangeHandler(SET_HOUSE_ID_PERMIT_FILTER)(undefined);
    makeChangeHandler(SET_FLAT_ID_PERMIT_FILTER)(undefined);
  };

  const handleChangeHouse = (value) => {
    makeChangeHandler(SET_HOUSE_ID_PERMIT_FILTER)(value);
    makeChangeHandler(SET_FLAT_ID_PERMIT_FILTER)(undefined);
  };

  const handleChangeFlat = (value) => {
    makeChangeHandler(SET_FLAT_ID_PERMIT_FILTER)(value);
  };

  return (
    <CardDesign
      style={{ backgroundColor: 'white' }}
      classname={cn(styles.card, {
        [styles.active]: !!streetId,
      })}
    >
      <CardDesign.Header
        heading="Адрес"
        icon={<AddressIcon />}
        activeCount={countValues(streetId, houseId, addressId)}
      />

      <CardDesign.Body>
        <div className={styles.content}>
          <div className={styles.flexBox}>
            <FilterField
              label="Улица"
              active={!!streetId}
            >
              <Select
                defaultActiveFirstOption={false}
                allowClear={true}
                placeholder="Выберите район"
                notFoundContent="нет данных"
                value={streetId}
                onChange={handleChangeStreet}
                showSearch={true}
                optionFilterProp="searchtext"
                disabled={isStreetByCompanyFetching}
                loading={isStreetByCompanyFetching}
              >
                {streetsByCompany?.map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    searchtext={item.name}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </FilterField>
            <FilterField
              label="Дом"
              active={!!houseId}
            >
              <Select
                defaultActiveFirstOption={false}
                allowClear={true}
                placeholder="Выберите район"
                notFoundContent="нет данных"
                value={houseId}
                onChange={handleChangeHouse}
                showSearch={true}
                optionFilterProp="searchtext"
                disabled={isHouseFetching || !streetId}
                loading={isHouseFetching}
              >
                {houses?.map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    searchtext={item.name}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </FilterField>
          </div>
          <FilterField
            label="Кв./офис"
            active={!!addressId}
          >
            <Select
              defaultActiveFirstOption={false}
              allowClear={true}
              placeholder="Выберите район"
              notFoundContent="нет данных"
              value={addressId}
              onChange={handleChangeFlat}
              showSearch={true}
              optionFilterProp="searchtext"
              disabled={isFlatFetching || !houseId}
              loading={isFlatFetching}
            >
              {getOptionsByDrobdownSelect(flats)}
            </Select>
          </FilterField>
        </div>
      </CardDesign.Body>
    </CardDesign>
  );
};

export default AddressFilterCard;
